<h3>Reports Ready to Submit <span *ngIf="count > 0">{{count}}</span></h3>
<div class="incomplete" *ngIf="!isLoading; else still_loading">
    <table *ngIf="!noData" class="table table-striped table-fixed">
        <tbody>
            <tr *ngFor="let a of applicants" class="applicant" (click)="openApplicant(a)">
                <td>
                    <app-round-image class="profile-image" [url]="a.profile" [useDefaultMissingImage]="true"
                        [width]="30" [height]="30"></app-round-image>
                    <span *ngIf="a.status > 0" container="body" ngbPopover="{{a.statusInfo}}"
                        popoverClass="slot-popover" triggers="mouseenter:mouseleave" popoverTitle="Note"><i
                            class="warning fa-solid fa-circle-exclamation"></i></span>
                    {{a.name}}
                </td>
                <td class="interviewer" *ngIf="showInterviewer">{{a.interviewerName}}</td>
                <td class="state">{{a.userState}}</td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="noData">
        <p>No interview reports ready to submit.</p>
    </div>
</div>
<ng-template #still_loading>
    <div class="loading">
        <div class="load_container">
            <img src="img/stopwatch.svg" class="bl">
        </div>
    </div>
</ng-template>